<template>
  <div>
    <h2 class="display-4 font-weight-bold"
      v-if="hasProduct">
      {{productById(productId).name}} {{productCountText}}
    </h2>
    <h2 class="display-4 font-weight-bold"
      v-if="hasCategory">
      <CmsText
          cms-key="reporting_form:category_title"
          :context="cmsContext"
          :category-id="categoryId"/>
    </h2>
    <QuestionList v-if="formFields.length"
      v-bind:formFields="formFields"
      v-bind:listIndex="groupIndex"
      v-model="formSubmitFields"/>
  </div>
</template>

<script>
import QuestionList from '@/components/QuestionList.vue';
import InputMixin from '@/mixins/InputMixin';
import CmsText from '@/components/CmsText.vue';

/**
 * Question Group
 *
 * This component is to group questions based on the product they are
 * associated with.
 */
export default {
  name: 'QuestionGroup',
  components: {
    QuestionList,
    CmsText,
  },
  mixins: [
    InputMixin,
  ],
  props: {
    /**
     * The array of form field configurations
     */
    formFields: Array,
    /**
     * The id of the associated group
     */
    groupId: String,
    /**
     * The array of form fields for submission
     */
    formSubmitFields: Object,
    /**
     * The index of the given question group in the form
     */
    groupIndex: Number,
  },
  computed: {
    /**
     * Gets the product id from the group id.
     * @returns {String}
     */
    productId() {
      return this.groupId ? this.groupId.split('__')[0] : null;
    },
    cmsContext() {
      return { category_name: this.productByCategoryId(this.productId).category_name };
    },
    categoryId() {
      return this.productByCategoryId(this.productId).category_id;
    },
  },
};
</script>
